import ThemedBlock from 'components/atoms/ThemedBlock'
import i18n from 'utils/i18n'
import Form, { createTranslationField } from 'components/molecules/Form'
import HelperManagementRights from 'utils/helper-management-rights'
import { managementRightsConstants } from 'utils/constants/management-right-constants'
import React, { useState } from 'react'
import HelperString from 'utils/helper-string'
import _ from 'lodash'
import Translate from 'utils/translate'
import { dataConstants } from 'services/redux/data/constants'
import { useSelector } from 'react-redux'
import ThemedImagePicker from 'components/management/molecules/ThemedImagePicker'
import HelperManagementBuilding, { BUILDING_UPLOAD_TYPE } from 'utils/helper/management/HelperManagementBuilding'
import { roomConstants } from 'utils/constants/room-constants'
import { FormFieldsConstants } from 'utils/constants/form-constants'
import { ThemedValues } from 'styles/themed'
import VStack from 'components/atoms/stack/VStack'

const RoomData = ({ room, saveForm }) => {
	
	const [ formKey, setFormKey ] = useState( HelperString.random() )
	
	const _languages = useSelector( state => {
		return state.data[dataConstants.LANGUAGES];
	} )
	
	const [ uploading, setUploading ] = useState( false )
	const [ roomImage, setRoomImage ] = useState( null )
	
	const onSelectImage = ( data ) => {
		const { base64 } = data;
		
		HelperManagementBuilding.uploadImage( base64, BUILDING_UPLOAD_TYPE.ROOM, room.guid, {
			onStart: () => {
				setUploading( true )
			},
			onSuccess: result => {
				setRoomImage( result.photo_url )
				setUploading( false )
			},
			onError: result => {
				setUploading( false )
			}
		});
	}
	
	// Create the default form values
	const formFields = [
		{
			name: 'name',
			label: i18n.t('management:form.name.title'),
			type: FormFieldsConstants.TEXT,
		},
		{
			name: 'kind',
			label: i18n.t('management:form.kind.title'),
			type: FormFieldsConstants.SELECT,
			options: [
				{
					value: roomConstants.KIND_ROOM,
					label: i18n.t(`page.create.option.kinds.${roomConstants.KIND_ROOM}.title`),
				},
				{
					value: roomConstants.KIND_MEETING_ROOM,
					label: i18n.t(`page.create.option.kinds.${roomConstants.KIND_MEETING_ROOM}.title`),
				}
			]
		},
		{
			name: 'available_for',
			label: i18n.t('management:form.available_for.short'),
			type: FormFieldsConstants.SELECT_AVAILABLE_FOR,
		},
		{
			name: 'aed',
			required: true,
			label: i18n.t('management:form.aed.title'),
			hint: i18n.t('management:form.aed.description'),
			type: FormFieldsConstants.SELECT_ACTIVE,
		},
		{
			name: 'active',
			label: i18n.t('management:form.active.title'),
			type: FormFieldsConstants.SELECT_ACTIVE
		}
	]
	
	// Add the translations
	if( _.size( _languages ) > 0 ) {
		formFields.push( {
			type: FormFieldsConstants.DIVIDER
		} );
		
		// Add the translation fields
		_.forEach( _languages, ( language ) => {
			_.forEach( { name: 'title', description: 'description' }, ( field, formName ) => {
				const { name, formField } = createTranslationField( formName, language );
				
				formFields.push( formField );
				
				const translation = Translate.formField( room, field, language );
				if( translation !== null ) {
					room[ name ] = translation;
				}
			})
		});
	}
	
	return (
		<VStack
			space={ ThemedValues.stackSpace }>
			
			<ThemedBlock
				header={ i18n.t('management:form_block.title_default') }
				shadow
				mediumPadding>
				
				<Form
					key={ HelperString.hash( 'form', formKey ) }
					values={ room }
					fields={ formFields }
					onSubmit={ saveForm }
					disabled={ !HelperManagementRights.hasEditRight( managementRightsConstants.EDIT.ROOMS ) }
				/>
			</ThemedBlock>
			
			<ThemedBlock
				header={ i18n.t('management:form_block.title_image') }
				shadow
				mediumPadding>
				
				<ThemedImagePicker
					source={ roomImage ?? room?.photo_url }
					onSelect={ onSelectImage }
					loading={ uploading }
				/>
			</ThemedBlock>
		</VStack>
	);
}

export default RoomData
